/* eslint-disable no-undef */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from '@reach/router';
import ReactGA from 'react-ga';
import { RootState } from '@/redux/reducers';
import { uiActions } from '@/redux/actions/ui';
import { AnalyticsAction, AnalyticsCategory } from '@/config/analytics';
import { regex, isInViewport } from '@/utils';
import { Entity } from '@/types';
import { footerItems } from './data';
import './styles.less';

interface BankApiFooterProps {
  bankName?: string;
}

const BankApiFooter: React.FC<BankApiFooterProps> = () => {
  const dispatch = useDispatch();
  const { organisation } = useSelector((state: RootState) => state.openBankingDiretory);
  // const webApp = detectWebApp[env.siteId as keyof typeof detectWebApp];

  const bankApiFooterRef = useRef<HTMLDivElement>(null);

  const [footerMenus, setFooterMenus] = useState<
    {
      label: string;
      url: string;
      absolutePath?: boolean;
      analytics: AnalyticsAction;
      show: boolean;
    }[]
  >([]);

  const getFooterFields = (entity?: Entity) => {
    if (entity) {
      const menus = footerItems.map((item) => {
        const url = (entity[item.field as keyof typeof entity] as string) || '';
        return {
          label: item.label,
          url: !url.includes('https://') ? `https://${url}` : url,
          absolutePath: regex.url.test(url),
          analytics: item.analytics,
          show: !!(url || item.show),
        };
      });
      return menus;
    }
    return footerItems;
  };

  useEffect(() => {
    const menus = getFooterFields(organisation);
    setFooterMenus(menus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organisation]);

  useEffect(() => {
    const updateFooterInViewport = () => {
      const footerInViewport = bankApiFooterRef.current
        ? isInViewport(bankApiFooterRef.current)
        : false;
      dispatch(uiActions.setBankApiFooterInViewport(footerInViewport));
    };
    window.addEventListener('scroll', updateFooterInViewport);
    return () => window.removeEventListener('scroll', updateFooterInViewport);
  }, [dispatch]);

  return (
    <div className="BankApiFooter">
     
    </div>
  );
};

export default BankApiFooter;
